import { OAuthProvider } from '../../enums/OAuthProvider';
import { OAuthSchema } from '../../definitions/schemas';

class OAuthService {
  private oAuth: OAuthSchema | undefined;

  /**
   * Sets the configuration urls for the oAuth providers, which dictate to which
   * URL the user is redirected for performing SSO with a particular provider.
   * The configuration comes from the bootstrap config request
   * @see https://gitlab.com/mindtickle/dsr/dsr-client/-/blob/track/integration/src/graphql/ConfigurationInterface.ts
   */
  public setupOAuthUrls(oAuth: OAuthSchema) {
    this.oAuth = oAuth;
  }

  /**
   * Opens the window with Enable Us api as target, to handle the oauth
   * redirection. This basically allows to open the provider's account selection
   * that is in charge of granting the permissions to allow Enable Us to
   * access the user's profile. It is expected for that page to redirect
   * back to the app in order to continue the OAuth flow.
   */
  public redirect(provider: OAuthProvider) {
    const url = this.getProviderUrl(provider);
    const oAuthRedirect = `${url}?redirect_uri=${window.location.origin}`;
    window.open(oAuthRedirect, '_self');
  }

  private getProviderUrl(provider: OAuthProvider): string {
    if (!this.oAuth) {
      throw new Error('OAuth URLs not set');
    }

    switch (provider) {
      case OAuthProvider.Azure:
        return this.oAuth.azureUrl;
      case OAuthProvider.Google:
        return this.oAuth.googleUrl;
      default:
        throw new Error('Invalid OAuth provider');
    }
  }
}

const OAuthServiceInstance = new OAuthService();
export default OAuthServiceInstance;
